// -----------------------------------------------------------------------------
// Helper utilities to safely examine scenario nodes stored either
// as array objects or as a serialized JSON string.  These are re-used in many
// places inside the component logic.
// -----------------------------------------------------------------------------
export const getScenarioNodesArray = (nodes) => {
    if (!nodes)
        return [];
    if (Array.isArray(nodes))
        return nodes;
    if (typeof nodes === 'string') {
        try {
            return JSON.parse(nodes);
        }
        catch (_a) {
            return [];
        }
    }
    return [];
};
// Returns true if scenario contains the given dialogue in ANY NPC node,
// regardless of connectionType (nested / none / link). This ensures that
// auto-update runs even for standalone NPCs that reference the dialogue.
export const doesScenarioContainDialogue = (scenario, dialogueId) => {
    return getScenarioNodesArray(scenario.nodes).some((node) => {
        const data = node === null || node === void 0 ? void 0 : node.data;
        if (!data)
            return false;
        if (data.dialogueId !== dialogueId)
            return false;
        // allowed connection types that still mean the node uses the dialogue
        const allowedConnectionTypes = new Set(['nested', 'none', 'link', undefined, null]);
        return allowedConnectionTypes.has(data.connectionType);
    });
};
